import { render, staticRenderFns } from "./StoryViewMessage.vue?vue&type=template&id=52367eaf&scoped=true&"
import script from "./StoryViewMessage.vue?vue&type=script&lang=js&"
export * from "./StoryViewMessage.vue?vue&type=script&lang=js&"
import style0 from "./StoryViewMessage.vue?vue&type=style&index=0&id=52367eaf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52367eaf",
  null
  
)

export default component.exports